import styled, { css } from 'styled-components';

export const SlideAreaWrapper = styled.div`
  flex: 0 0 auto;

  display: block;
  overflow: hidden;

  border-bottom: 1px solid var(--border-color);
  margin-bottom: 1em;
  padding: 0 1em 1em;

  --swiper-navigation-color: var(--brand-color);

  .swiper-container {
    margin: 1em 0;
    padding: 0 2.5em;
  }

  .swiper-button-prev,
  .swiper-button-next {
    width: 2.5em;
    background-color: var(--background-color);
    top: 0;
    bottom: 0;
    margin: 0;
    height: auto;

    &:after {
      font-size: 1.4em;
      font-weight: 600;
    }
  }

  .swiper-button-prev {
    left: 0;
  }

  .swiper-button-next {
    right: 0;
    width: 2.5em;
  }
`;

export const Slide = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;

  background: transparent;
  border: 2px solid var(--brand-color);
  border-radius: 500rem;
  color: var(--text-color);

  cursor: pointer;

  font-size: 0.8em;
  text-align: center;

  height: 3rem;
  width: 3rem;

  transition: all 0.3s ease;

  .thick {
    font-weight: 600;
  }

  ${(props) => props.active
    && css`
      background: var(--brand-color);
      color: white;
    `}
`;

export const Label = styled.p`
  color: var(--text-color);
  font-size: 0.9em;
  margin: 0 0 0.5em;
  padding: 0 1em;

  ${(props) => props.active
    && css`
      color: var(--brand-color);
      font-weight: 600;
    `}
`;

export const TimeSlotsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 1em;
  padding: 1em;
`;

export const TimeSLotItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5em 1em;

  background: var(--background-secondary-color);
  color: var(--text-color);

  cursor: pointer;

  ${(props) => props.active
    && css`
      background: var(--brand-color);
      color: white;
      font-weight: 600;
    `}
`;
